/* ZAES KIDS — PDP 2026 layout orchestration.
   Purpose: move existing, already-functional Shopify controls into the approved
   visual hierarchy without duplicating forms, variant selectors or cart logic. */
(function () {
  'use strict';

  var initializedRoots = new WeakSet();
  var mobileQuery = window.matchMedia('(max-width: 989px)');

  function parseVariant(root) {
    try {
      var node = root.querySelector('variant-selects [data-selected-variant]');
      if (!node || !node.textContent.trim()) return null;
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function getBlockWrapper(node, info) {
    if (!node) return null;
    var editorWrapper = node.closest('[data-shopify-editor-block]');
    if (editorWrapper && info.contains(editorWrapper)) return editorWrapper;
    return node;
  }

  function createStockStatus() {
    var el = document.createElement('div');
    el.className = 'zk-pdp-buybox__status';
    el.innerHTML = '<strong data-zk-pdp-stock-label>Disponible</strong><span>Compra con respaldo ZAES KIDS.</span>';
    return el;
  }

  function createTrustBlock() {
    var el = document.createElement('div');
    el.className = 'zk-pdp-buybox__trust';
    el.innerHTML = [
      '<div class="zk-pdp-buybox__trust-item">',
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6H5v4"></path><path d="M5 6l4-4"></path><path d="M5 6h8a6 6 0 1 1 0 12H9"></path></svg>',
        '<div><strong>Cambios y devoluciones</strong><span>Consulta las condiciones aplicables a tu compra.</span></div>',
      '</div>',
      '<div class="zk-pdp-buybox__trust-item">',
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 4.5 6v5.2c0 4.8 3.1 8.2 7.5 9.8 4.4-1.6 7.5-5 7.5-9.8V6L12 3Z"></path><path d="m8.5 12 2.2 2.2 4.8-5"></path></svg>',
        '<div><strong>Compra segura</strong><span>Tu pago y tus datos se procesan de forma protegida.</span></div>',
      '</div>'
    ].join('');
    return el;
  }

  function ensurePriceWrap(root) {
    var price = root.querySelector('[id^="price-"]');
    if (!price || price.closest('.zk-pdp-price-wrap')) return;

    var wrap = document.createElement('div');
    wrap.className = 'zk-pdp-price-wrap';
    price.parentNode.insertBefore(wrap, price);
    wrap.appendChild(price);

    var chip = document.createElement('span');
    chip.className = 'zk-pdp-discount-chip';
    chip.setAttribute('aria-label', 'Descuento');
    wrap.appendChild(chip);
  }

  function updateDiscount(root, variant) {
    var chip = root.querySelector('.zk-pdp-discount-chip');
    if (!chip) return;

    var compare = variant && Number(variant.compare_at_price || 0);
    var price = variant && Number(variant.price || 0);
    if (compare > price && price > 0) {
      var pct = Math.round(((compare - price) / compare) * 100);
      chip.textContent = pct + '% OFF';
      chip.classList.add('is-visible');
    } else {
      chip.textContent = '';
      chip.classList.remove('is-visible');
    }
  }

  function updateAvailability(root, variant) {
    var status = root.querySelector('.zk-pdp-buybox__status');
    var label = root.querySelector('[data-zk-pdp-stock-label]');
    if (!status || !label) return;

    var available;
    if (variant && typeof variant.available === 'boolean') {
      available = variant.available;
    } else {
      var submit = root.querySelector('[id^="ProductSubmitButton-"]');
      available = submit ? !submit.disabled : true;
    }

    status.classList.toggle('is-sold-out', !available);
    label.textContent = available ? 'Disponible' : 'Agotado';
  }

  function moveIconBenefits(root) {
    var grid = root.querySelector('.product');
    var media = root.querySelector('.product__media-wrapper');
    var buybox = root.querySelector('.zk-pdp-buybox');
    var benefits = root.querySelector('.zk-pdp-icon-benefits-slot');
    if (!grid || !media || !buybox || !benefits) return;

    if (mobileQuery.matches) {
      if (benefits.parentNode !== grid || benefits.previousElementSibling !== buybox) {
        buybox.insertAdjacentElement('afterend', benefits);
      }
    } else if (benefits.parentNode !== media) {
      media.appendChild(benefits);
    }
  }

  function createBuybox(root, info, grid) {
    var buybox = root.querySelector('.zk-pdp-buybox');

    if (!buybox) {
      buybox = document.createElement('aside');
      buybox.className = 'zk-pdp-buybox';
      buybox.setAttribute('data-zk-pdp-buybox', '');
      buybox.setAttribute('aria-label', 'Compra y entrega');
      grid.appendChild(buybox);
    }

    if (!buybox.querySelector('.zk-pdp-buybox__status')) {
      buybox.insertBefore(createStockStatus(), buybox.firstChild);
    }

    var trust = buybox.querySelector('.zk-pdp-buybox__trust');
    if (!trust) {
      trust = createTrustBlock();
      buybox.appendChild(trust);
    }

    var delivery = info.querySelector('[data-zk-delivery-promise]');
    var quantity = info.querySelector('[id^="Quantity-Form-"]');
    var form = info.querySelector('product-form.product-form');
    var buyBlock = getBlockWrapper(form, info);
    var whatsapp = info.querySelector('.zk-whatsapp-block');
    var payMethods = info.querySelector('.zk-paymethods-pdp');

    /* Keep the final retail hierarchy stable from the first rendered frame.
       The shell already exists in Liquid; functional controls are moved into it
       before the browser gets a chance to present the old two-column layout. */
    [delivery, quantity, buyBlock, whatsapp].forEach(function (node) {
      if (node && !buybox.contains(node)) buybox.insertBefore(node, trust);
    });

    if (payMethods && !buybox.contains(payMethods)) buybox.appendChild(payMethods);

    return buybox;
  }

  function moveAccordions(root, info, grid) {
    var details = root.querySelector('.zk-pdp-mobile-details');
    if (!details) {
      details = document.createElement('div');
      details.className = 'zk-pdp-mobile-details';
      details.setAttribute('aria-label', 'Detalles del producto');
      grid.insertAdjacentElement('afterend', details);
    }

    Array.from(info.querySelectorAll('.product__accordion')).forEach(function (accordion) {
      details.appendChild(accordion);
    });
  }

  function initRoot(root) {
    if (!root || initializedRoots.has(root)) return;

    var grid = root.querySelector('.product');
    var info = root.querySelector('.product__info-container');
    if (!grid || !info) return;

    initializedRoots.add(root);
    root.classList.add('zk-pdp-2026');
    document.body.classList.add('zk-pdp-2026-page');

    ensurePriceWrap(root);
    createBuybox(root, info, grid);
    moveAccordions(root, info, grid);
    moveIconBenefits(root);
    root.classList.add('zk-pdp-layout-ready');

    var variant = parseVariant(root);
    updateAvailability(root, variant);
    updateDiscount(root, variant);
  }

  function boot() {
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(initRoot);
  }

  window.ZaesKidsPdp2026 = window.ZaesKidsPdp2026 || {};
  window.ZaesKidsPdp2026.boot = boot;

  function refreshForVariant(sectionId, variant) {
    var root = null;
    if (sectionId) {
      root = Array.from(document.querySelectorAll('product-info[id^="MainProduct-"]')).find(function (item) {
        return String(item.dataset.section || '') === String(sectionId);
      }) || null;
    } else {
      root = document.querySelector('product-info[id^="MainProduct-"]');
    }
    if (!root) return;

    window.setTimeout(function () {
      ensurePriceWrap(root);
      updateAvailability(root, variant || parseVariant(root));
      updateDiscount(root, variant || parseVariant(root));
      moveIconBenefits(root);
    }, 0);
  }

  /* The main product markup is already parsed when this asset is executed from
     the end of main-product.liquid. Boot immediately so the three-column PDP is
     assembled in the same parser task, before the legacy layout can be painted.
     The DOMContentLoaded hook remains as a harmless fallback for alternate loads. */
  var variantSubscriptionBound = false;

  function bindVariantSubscription() {
    if (variantSubscriptionBound) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data ? event.data : {};
      refreshForVariant(data.sectionId, data.variant || null);
    });
    variantSubscriptionBound = true;
  }

  boot();
  bindVariantSubscription();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
      bindVariantSubscription();
    }, { once: true });
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(boot, 0);
  });

  document.addEventListener('product-info:loaded', function () {
    window.setTimeout(boot, 0);
  });

  mobileQuery.addEventListener('change', function () {
    document.querySelectorAll('product-info.zk-pdp-2026').forEach(moveIconBenefits);
  });

  document.addEventListener('variant:change', function () {
    document.querySelectorAll('product-info.zk-pdp-2026').forEach(function (root) {
      refreshForVariant(root.dataset.section, parseVariant(root));
    });
  });
})();
